import React from 'react';
import ReactSVG from 'react-svg';
import styled from 'styled-components';
import { Icon } from './Icon';
import * as icons from '../theme/icons';
import ratio from '../theme/icons/ratio';
import { Maybe } from '../types';

export type IconKey = keyof typeof icons;

export interface SvgIconProps {
  icon: IconKey;
  className?: string;
  IconHeight?: number;
  marginRight?: number;
  svgStyles?: React.CSSProperties;
}

export const getSvgIconKey = (iconKey = ''): Maybe<IconKey> => {
  if (iconKey in icons) {
    return iconKey as IconKey;
  }
  return null;
};

const SvgIcon = ({ icon, className = '', IconHeight = 1, marginRight = 0, svgStyles = {} }: SvgIconProps) => {
  const path: string = icons[icon];
  const width = ratio[icon] ? ratio[icon].width : 24;
  const height = ratio[icon] ? ratio[icon].height : 24;

  if (path) {
    return (
      <Icon height={IconHeight} marginRight={marginRight} className={className}>
        {/* TODO: set dynamic aspect ratio */}
        <canvas width={width} height={height} />
        <ReactSVG path={path} svgStyle={svgStyles} />
      </Icon>
    );
  }
  console.warn(`SvgIcon: icon '${icon}' not found 😭`);
  return null;
};

const StyledSvgIcon = styled(SvgIcon)``;

const StyledSvgIconBefore = styled.i<SvgIconProps>`
  &:before {
    content: url(${(props) => icons[props.icon]});
  }
`;

export { StyledSvgIconBefore as SvgIconBefore, StyledSvgIcon as SvgIcon };
